import {Component, inject, OnInit} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {ResellerTuningCombinationsModel} from '../models/Reseller-tuning-combinations-model';
import {AuthService} from '../service/auth.service';
import {ResellerTuningCombinationsService} from '../service/reseller-tuning-combinations.service';

@Component({
    selector: 'app-reseller-tuning-combinations',
    templateUrl: './reseller-tuning-combinations.component.html',
    styleUrl: './reseller-tuning-combinations.component.css'
})
export class ResellerTuningCombinationsComponent implements OnInit {
    tuningOptions = new FormControl('', Validators.required);
    resellerProjectType = new FormControl('', Validators.required);
    searchQuery = '';

    get filteredCombinations(): ResellerTuningCombinationsModel[] {
        const query = this.searchQuery.trim().toLowerCase();
        const rows = this.resellerTuningCombinationsService.resellerTuningCombinations();
        return query ? rows.filter(row =>
            row.tuningOptions?.toLowerCase().includes(query) ||
            row.resellerProjectType?.toLowerCase().includes(query)
        ) : rows;
    }

    originalIndex(row: ResellerTuningCombinationsModel): number {
        return this.resellerTuningCombinationsService.resellerTuningCombinations().findIndex(item => item.id === row.id);
    }

    resellerTuningCombinationsService = inject(ResellerTuningCombinationsService);
    authService = inject(AuthService);

    ngOnInit() {
        this.resellerTuningCombinationsService.resetTableValues();
        this.allResellerCombinations();
    }

    allResellerCombinations() {
        this.resellerTuningCombinationsService.getAllResellerCombinations();
    }

    tuningOptionsError(currentId?: number): string | undefined {
        return this.resellerTuningCombinationsService.validateResellerOptions(
            this.tuningOptions.value, this.resellerProjectType.value, currentId
        ).tuningOptions;
    }

    projectTypeError(currentId?: number): string | undefined {
        return this.resellerTuningCombinationsService.validateResellerOptions(
            this.tuningOptions.value, this.resellerProjectType.value, currentId
        ).resellerProjectType;
    }

    canSave(currentId?: number): boolean {
        const errors = this.resellerTuningCombinationsService.validateResellerOptions(
            this.tuningOptions.value, this.resellerProjectType.value, currentId
        );
        return !this.resellerTuningCombinationsService.isWaitingForResponse() &&
            Object.keys(errors).length === 0;
    }

    saveNewRow() {
        if (!this.canSave()) {
            return;
        }

        this.resellerTuningCombinationsService.addNewResellerOptions({
            id: 0,
            tuningOptions: this.tuningOptions.value ?? '',
            resellerProjectType: this.resellerProjectType.value ?? ''
        });
    }

    toggleEditView(index: number, resellerCombinations: ResellerTuningCombinationsModel) {
        if (!this.authService.isAdmin()) return;
        this.resellerTuningCombinationsService.closeRow();
        this.resellerTuningCombinationsService.toggleEditView(index);
        this.tuningOptions.setValue(resellerCombinations.tuningOptions || '');
        this.resellerProjectType.setValue(resellerCombinations.resellerProjectType || '');
    }

    editResellerCombinations(id: number) {
        if (!this.canSave(id)) {
            return;
        }

        this.resellerTuningCombinationsService.editResellerOptions(id, {
            id,
            tuningOptions: this.tuningOptions.value ?? '',
            resellerProjectType: this.resellerProjectType.value ?? ''
        });
    }

    deleteItemFromDatabase(id: number) {
        this.resellerTuningCombinationsService.deleteItemFromDatabase(id);
    }

    toggleInputRow() {
        this.resellerTuningCombinationsService.closeEditedItem();
        this.tuningOptions.reset('');
        this.resellerProjectType.reset('');
        this.resellerTuningCombinationsService.toggleNewInputRow();
    }
}
